import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import UserProfileHeader from '../user-profile/UserProfileHeader';
import UserProfileDetails from '../user-profile/UserProfileDetails';
import UserPhotos from '../user-profile/UserPhotos';
import UserAboutText from '../user-profile/UserAboutText';
import { fetchUserData, fetchUserStatData } from '../../api/user';
import UserProfileSkeleton from './UserProfileSkeleton';
import EditLuxeInfo from '../ChatMessenger/bot-profile-chat/EditLuxeInfo';

// Renders a profile read-only (no edit affordances) — used by the Subscribed
// User List and Verification Requests. The subscribed list deliberately keeps
// members whose account was deleted ("subscription still counted"), so this
// component has to survive a delete-log dump, which is a sparser document than
// a live user: `preferences` and friends can be missing entirely on the oldest
// rows. `/admin/user/:id` resolves those from the delete log and flags them
// `isDeletedAccount`.
const ProfileCard = ({ userId }) => {
  const [userData, setUserData] = useState(false);
   const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    try {
      // isAbort:false — getRequest keys in-flight GETs on the path, so another
      // component reading the SAME user id cancelled this one and left the
      // modal stuck on the skeleton. With aborts off, "done loading and still
      // no user" unambiguously means not found.
      await fetchUserData(userId, setUserData, false, undefined, { isAbort: false });
    } catch (error) {
      console.error('Error while loading real-time data', error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <UserProfileSkeleton />;
  }

  // Previously this shared the skeleton branch, so a profile that failed to load
  // spun on a loading placeholder forever with no explanation.
  if (!userData) {
    return (
      <div className="text-center py-5">
        <div className="font-18 fw-medium text-black">This profile could not be loaded</div>
        <div className="font-14 text-secondary pt-8">The account may have been permanently removed.</div>
      </div>
    );
  }

  return (
    <div className="position-relative z-2 ">
      <section className="border-top-0 pt-28">
        <div className="container">
          {userData?.isDeletedAccount && (
            <div
              className="font-14 fw-medium"
              style={{ background: '#fdecea', color: '#cf4233', borderRadius: 8, padding: '10px 14px', marginBottom: 16 }}
            >
              This member deleted their account — the profile below is the archived copy and is read-only.
            </div>
          )}
          <div className="user-profile-card">
            <UserProfileHeader userData={userData} />
          </div>
          <div className="d-flex align-items-start">
            <div
              className="UserProfileDetailsDv w-100"
              style={{
                padding: '40px 30px 0 20px',
                maxWidth: '370px',
                margin: '0 auto',
              }}
            >
              <UserProfileDetails userData={userData} />
            </div>
            <div className="w-100 px-32 pt-24 border-start">
              <div className="w-100 userPhoto01 pb-16">
                <div className="font-24 font-m fw-medium text-black pb-16">
                  Public Photos
                </div>
                <UserPhotos
                  images={userData?.publicPhotos ? userData?.publicPhotos : []}
                  defaultLimit={6}
                />
              </div>
              {/* <div className="py-32">
                <div className="d-flex justify-content-between align-items-center font-24 font-m fw-medium text-black pb-16">
                  Private Photos
                </div>
                <UserPhotos
                  images={
                    userData?.privatePhotos ? userData?.privatePhotos : []
                  }
                  defaultLimit={6}
                />
              </div> */}
              <UserAboutText userData={userData} />
              <div className="aboutText">
                <div className="Text border-top py-32">
                  <h3 className="font-24 font-m fw-medium text-black pb-16 mb-0">
                    What I Am Looking For
                  </h3>
                  {/* Optional-chained: a delete-log dump can omit `preferences`
                      entirely, which threw here and blanked the whole modal. */}
                  <p>{userData?.preferences?.aboutPartnerDescription}</p>
                </div>
              </div>
                <div className="aboutText">
                <div className="Text border-top py-32">
              {/* {userData?.luxuryInterests && <EditLuxeInfo memberData={userData} titleClass="font-24 font-m fw-medium text-black mb-0" isEditBtn={false} className="pdx_profile" isRtsdbtnchat="px14font" />} */}
                </div>
                </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileCard;
